import { inject } from '@angular/core';
import { SideMenuService } from './services/side-menu/side-menu.service';
import { of, forkJoin, from } from 'rxjs';
import { concatMap, map } from 'rxjs/operators';
import { CustomLoginService } from '@privatelib/ngx18-authz-dev';
import { LOOKUP_KEY, LookupService } from './services/lookup/lookup.service';
import { SessionInactivityService } from './services/session-inactivity/session-inactivity.service';

interface Validity {
    days_to_expiry: number;
    notify: number;
}

interface ResponseBody {
    validity: Validity;
}

interface Response {
    body: ResponseBody;
}


export const initialDataResolver = () => {
    const sideMenuService = inject(SideMenuService);
    const authorize = inject(CustomLoginService);
    const lookupService = inject(LookupService);
    const sessionInactivityService = inject(SessionInactivityService);

    return forkJoin([
        sideMenuService.setMenus(),
        validateLicense(),
        lookupService.getLookupValuesByType(LOOKUP_KEY.SESSION_TIMEOUT_IN_MIN)
    ])

    function validateLicense() {
        return from(authorize.getValidity()).pipe(
            concatMap((response: Response) => {
                const days_to_expiry = response?.body?.validity?.days_to_expiry;
                const isLicenseExpired = days_to_expiry && days_to_expiry < 0;

                //init on login to check the session inactivity
                sessionInactivityService.initOnLogin()
                    .then(() => console.log("Started tracking session inactivity...")
                    ).catch((err) => {
                        console.error("Session inactivity issue:\n", err);
                    });

                if (isLicenseExpired) {
                    // If the license is expired, set menus with expired flag
                    return sideMenuService.setMenus(true).pipe(
                        map(() => true) // Return `true` after setMenus completes
                    );
                } else {
                    // If the license is not expired, return `true`
                    return of(true);
                }
            })
        );
    }
};

